import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { linearConfigurationRequestQuoteConfirmationPageQueryOptions } from "~/app/api/pageData/linearConfigurationRequestQuoteConfirmationPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createLinearRequestQuoteSuccessPage } from "~/features/configurator/Linear/components/LinearRequestQuoteSuccessPage";

function LinearConfigurationRequestQuoteConfirmationRoute() {
  const result = useLoaderData({
    from: "/requestLinearConfigurationQuote/confirmation",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createLinearRequestQuoteSuccessPage()}
    </StorefrontShellFrame>
  );
}

export async function loadLinearConfigurationRequestQuoteConfirmationPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(
    linearConfigurationRequestQuoteConfirmationPageQueryOptions(),
  );

  return unwrapPageInitialData(result);
}

export const linearConfigurationRequestQuoteConfirmationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/requestLinearConfigurationQuote/confirmation",
  loader: async ({ context }) => loadLinearConfigurationRequestQuoteConfirmationPageData(context),
  component: LinearConfigurationRequestQuoteConfirmationRoute,
});
